import { Component, Inject, OnInit, OnDestroy, Optional } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, Subscription } from 'rxjs';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';

@Component({
	selector: 'app-rapid-creditors-modal',
	templateUrl: './rapid-creditors-modal.component.html',
	styleUrls: ['./rapid-creditors-modal.component.scss'],
	standalone: false,
})
export class RapidCreditorsModalComponent implements OnInit, OnDestroy {
	private readonly _onDestroy = new Subject<void>();
	private parentSub = new Subscription();
	protected tradesList: any;
	protected collectionList: any;

	protected otherCreditor: boolean = false;
	protected otherCreditor_name = new UntypedFormControl('');
	protected otherCreditor_amount = new UntypedFormControl(null);

	constructor(
		private readonly apiService: LegacyApiService,
		public dialogRef: MatDialogRef<RapidCreditorsModalComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
	) { dialogRef.disableClose = true; }

	private addDefaultCheckboxes(tradeList: any, collectionList: any) {
		if (tradeList) {
			if (!tradeList?.[0].hasOwnProperty('Referral')) {
				for (var i = 0; i < tradeList?.length; i++) {
					tradeList[i]['Referral'] = false;
				}
			}
			if (!tradeList?.[0].hasOwnProperty('Cons')) {
				for (var i = 0; i < tradeList?.length; i++) {
					tradeList[i]['Cons'] = false;
				}
			}
		}
		if (collectionList) {
			if (!collectionList?.[0].hasOwnProperty('Referral')) {
				for (var i = 0; i < collectionList?.length; i++) {
					collectionList[i]['Referral'] = false;
				}
			}
			if (!collectionList?.[0].hasOwnProperty('Cons')) {
				for (var i = 0; i < collectionList?.length; i++) {
					collectionList[i]['Cons'] = false;
				}
			}
		}
	}

	private getTrades() {
		this.tradesList =
			this.data.tuReport?.REL4Report.TU_FFR_Report[0]?.Trades?.[0]?.Trade;
		this.collectionList =
			this.data.tuReport?.REL4Report.TU_FFR_Report[0]?.Collections?.[0]?.Collection;
		this.addDefaultCheckboxes(this.tradesList, this.collectionList);
	}

	public ngOnInit(): void {
		this.getTrades();
	}

	ngOnDestroy() {
		this.parentSub.unsubscribe();
		this._onDestroy.next();
		this._onDestroy.complete();
	}

	protected onDismiss(): void {
		this.dialogRef.close(false);
	}

	protected submitRapidApproval() {
		this.dialogRef.close({
			tuReport: this.data.tuReport,
			otherCreditorObject: {
				creditor: this.otherCreditor_name.value,
				amount: this.otherCreditor_amount.value,
			},
		});
	}
}
